import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { isEmpty } from "lodash";
import { GlobalSpinner, showSuccessAlert, showErrorAlert } from "../../../../../global/globalFunctions";
import { AddFBRCompanyApi } from "./FBRCompanyAction";
import { setHeading } from "../../../accounts/account.actions";
import { addProductImage } from "../../AddDetails/AddProduct/Product.action";
import { Button } from "@mui/material";
import Select from "react-select";
import SendIcon from "@mui/icons-material/Send";
import ImageUploader from "react-images-upload";


const FBRAddCompany = (props) => {
    const initialFormState = {
        companyName: "",
        companyLocation: "",
        ownerName: "",
        ntn: "",
        phone: "",
        email: "",
        strn: "",
        sandBoxToken: "",
        productiontoken: "",
    };
    const [form, setForm] = useState(initialFormState);
    const [province, setProvince] = useState();

    useEffect(() => {
        props.setHeading("Add Company");
    }, []);

    const handleChange = (field) => (e) => {
        setForm({ ...form, [field]: e.target.value });
    };

    function SaveCompany() {
        props.AddFBRCompanyApi({
            ...form,
            province,
            image: props.ProductImageURL.file,
        },
            showSuccessAlert,
            showErrorAlert
        );
        setForm(initialFormState);
        props.ProductImage({ image: "" });
    }

    const onDrop = (pictureFiles) => {
        props.ProductImage({
            image: pictureFiles[0]
        });
    };


    let provinces = [{
        value: "PUNJAB",
        label: "PUNJAB"
    },
    {
        value: "BALOCHISTAN",
        label: "BALOCHISTAN"
    },
    {
        value: "AZAD JAMMU AND KASHMIR",
        label: "AZAD JAMMU AND KASHMIR"
    },
    {
        value: "CAPITAL TERRITORY",
        label: "CAPITAL TERRITORY"
    },
    {
        value: "KHYBER PAKHTUNKHWA",
        label: "KHYBER PAKHTUNKHWA"
    },
    {
        value: "SINDH",
        label: "SINDH"
    },
    {
        value: "GILGIT BALTISTAN",
        label: "GILGIT BALTISTAN"
    }];
    const handleChangeProvince = (selectedOption) => {
        setProvince(selectedOption.label);
    };
    const GetProvinceList = provinces.map((x) => {
        let data = { value: x.value, label: x.label };
        return data;
    });

    return (
        <>
            {props.isAddingFBRCompany ? (
                <GlobalSpinner />
            ) : (
                <Container fluid>
                    <Form>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Company Name *</b></Form.Label>
                                    <Form.Control
                                        // placeholder="Company Name"
                                        onChange={handleChange("companyName")}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Company Location</b></Form.Label>
                                    <Form.Control
                                        // placeholder="Company Location"
                                        onChange={handleChange("companyLocation")}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>NTN / CNIC *</b></Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={form.ntn}
                                        onChange={handleChange("ntn")}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Phone *</b></Form.Label>
                                    <Form.Control
                                        value={form.phone}
                                        onChange={handleChange("phone")}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Email *</b></Form.Label>
                                    <Form.Control
                                        value={form.email}
                                        onChange={handleChange("email")}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>STRN</b></Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={form.strn}
                                        onChange={handleChange("strn")}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Owner Name *</b></Form.Label>
                                    <Form.Control
                                        value={form.ownerName}
                                        onChange={handleChange("ownerName")}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Select Province *</b></Form.Label>
                                    <Select
                                        // placeholder="Select Province"
                                        onChange={handleChangeProvince}
                                        options={GetProvinceList}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>FBR SandBox Token *</b></Form.Label>
                                    <Form.Control
                                        value={form.sandBoxToken}
                                        onChange={handleChange("sandBoxToken")}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>FBR Production Token *</b></Form.Label>
                                    <Form.Control
                                        value={form.productiontoken}
                                        onChange={handleChange("productiontoken")}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Label><b>Upload Company Logo </b></Form.Label>
                                <ImageUploader
                                    withIcon={false}
                                    buttonText="Upload Logo"
                                    onChange={onDrop}
                                    imgExtension={[".jpg", ".png", ".gif"]}
                                    maxFileSize={5242880}
                                    singleImage
                                    withPreview
                                />
                            </Col>
                        </Row>

                        <div className="sendDiv" >
                            <Button variant="contained" endIcon={<SendIcon />} size="large"
                                disabled={
                                    isEmpty(form.companyName) || isEmpty(form.ntn) || isEmpty(form.phone) || isEmpty(form.email) || isEmpty(province)
                                    // isEmpty(props.ProductImageURL.file)
                                }
                                onClick={SaveCompany}
                            >
                                SAVE
                            </Button>
                        </div>

                    </Form>
                </Container>
            )}
        </>
    );
};

const mapDispatchToProps = (dispatch) => ({
    AddFBRCompanyApi: (data, success, error) => dispatch(AddFBRCompanyApi(data, success, error)),
    setHeading: (data) => dispatch(setHeading(data)),
    ProductImage: (data) => dispatch(addProductImage(data))
});

const mapStateToProps = (state) => ({
    isAddingFBRCompany: state.FBRCompanyReducer.isAddingFBRCompany,
    ProductImageURL: state.ProductReducer.ProductImageURL
});

export default connect(mapStateToProps, mapDispatchToProps)(FBRAddCompany);